module.exports = __webpack_public_path__ + "img/fig9.26.af3d0089.png";